import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";

// Compact floating "Tap to Call" button — single line, mobile only,
// appears once the user scrolls past the hero.
export default function StickyCallButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:7722890405"
      data-testid="sticky-call-button"
      aria-label="Call 772-289-0405"
      className={`lg:hidden fixed bottom-5 right-5 z-40
                  inline-flex items-center gap-2 pl-3 pr-5 py-3 rounded-full
                  bg-brand-pink text-white font-bold text-sm whitespace-nowrap
                  shadow-2xl shadow-pink-500/40 ring-2 ring-white/80
                  transition-all duration-300 ease-out
                  ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"}`
                  .replace(/\s+/g, " ")}
    >
      <span className="grid place-items-center w-8 h-8 rounded-full bg-white/20">
        <Phone className="w-4 h-4" />
      </span>
      (772) 289-0405
    </a>
  );
}
